export const defaultUserData = { server_id: 1, team_id: 1 };
